export default __webpack_public_path__ + "static/media/qt-icon-active.1c81e5c0.svg";